import { ComponentType } from 'react';

export function getFlag(ImageComponent: ComponentType<React.ImgHTMLAttributes<HTMLImageElement>>, locale?: string) {
    const code = locale?.split('-')?.[1]?.toLowerCase();
    return code ? <ImageComponent loading="lazy" src={`https://flagcdn.com/192x144/${code}.png`} alt={code} /> : <></>;
}
